import React, { useState,} from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import SkillsSection from './components/Skills/SkillsSection';
import FeaturedApp from './components/FeaturedApp';
import ProjectsSection from './components/Projects/ProjectsSection';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Analytics } from "@vercel/analytics/react";
function App() {
  const [activeSection, setActiveSection] = useState('hero');

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setActiveSection(sectionId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <Navbar activeSection={activeSection} scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <About />
      <SkillsSection />
      <FeaturedApp />   
      <ProjectsSection />
      <Experience />
      <Contact />
      <Footer />
      <Analytics />
    </div>
  );
}

export default App;
